import React from 'react'
import { Link } from 'react-router-dom'

import SButton from '../SButton'

const BASE = `
    inline-flex items-center justify-center
    gap-(--x007)!

    h-11
    min-h-8!
    px-0!
    pl-1!
    pr-[9px]!
    rounded-[5px]!

    border!

    text-sm font-semibold
    whitespace-nowrap!

    hover:opacity-[0.92]!

    active:[background:white]!

    [&>span]:inline-flex
    [&>span]:items-center
    [&>span]:gap-2
    [&>span]:leading-none

    [&_.ant-btn-icon]:m-0!
    [&_.ant-btn-icon]:inline-flex
    [&_.ant-btn-icon]:items-center
`

const OUTLINED = 'border-[#272727] text-[#272727] hover:text-[#272727]!'

const FILLED = `
    border-transparent!
    [background:var(--book-call-bg)]!
    text-white
    shadow-(--book-call-shadow)!
    hover:text-white!
    hover:border-transparent!
`

export default function SButtonLink({ value, to, target, className, linkClassName, ...rest }) {
    return (
        <Link to={to} target={target} className={linkClassName}>
            <SButton value={value} className={`${BASE} ${rest.outlined ? OUTLINED : FILLED} ${className}`} {...rest} />
        </Link>
    )
}
